@if (!match?.winningSide) {
<ion-grid
  class="content-width ion-no-padding"
  [style.--background]="getColor(2)"
>
  <!-- Stats Board -->

  @if (shotStatsBoard && bhs.getLastPoint(match)?.server) {
  <!-- Row #1: ACE | RETURN WINNER | WINNER -->
  <ion-row>
    <ion-col
      class="ion-no-padding"
      size="6"
      [ngStyle]="{ 'height.px': (screenHeight - 204) / 3 }"
    >
      <ion-button
        [disabled]="isBoardDisabled"
        *ngIf="
          bhs.getLastPoint(match).server.sideNumber === 1 && !isStatsBoard;
          else player1ReturnWinner
        "
        class="ion-no-margin button"
        [style.--background]="getColor(1)"
        (click)="ace(1)"
        translate
      >
        Ace
      </ion-button>

      <ng-template #player1ReturnWinner>
        <ion-button
          [disabled]="isBoardDisabled"
          *ngIf="!isStatsBoard; else player1Winner"
          class="ion-no-margin button"
          [style.--background]="getColor(1)"
          (click)="returnWinner(1)"
        >
          {{ "Return" | translate }}<br />{{ "Winner" | translate }}
        </ion-button>
      </ng-template>

      <ng-template #player1Winner>
        <ion-button
          [disabled]="isBoardDisabled"
          class="ion-no-margin button"
          [style.--background]="getColor(1)"
          (click)="winner(1)"
          translate
        >
          Winner
        </ion-button>
      </ng-template>
    </ion-col>

    <ion-col
      class="ion-no-padding"
      size="6"
      [ngStyle]="{ 'height.px': (screenHeight - 204) / 3 }"
    >
      <ion-button
        [disabled]="isBoardDisabled"
        *ngIf="
          bhs.getLastPoint(match).server.sideNumber === 2 && !isStatsBoard;
          else player2ReturnWinner
        "
        [style.--background]="getColor(2)"
        class="ion-no-margin button"
        (click)="ace(2)"
        translate
      >
        Ace
      </ion-button>

      <ng-template #player2ReturnWinner>
        <ion-button
          [disabled]="isBoardDisabled"
          *ngIf="!isStatsBoard; else player2Winner"
          [style.--background]="getColor(2)"
          class="ion-no-margin button"
          (click)="returnWinner(2)"
        >
          {{ "Return" | translate }}<br />{{ "Winner" | translate }}
        </ion-button>
      </ng-template>

      <ng-template #player2Winner>
        <ion-button
          [disabled]="isBoardDisabled"
          *ngIf="isStatsBoard"
          [style.--background]="getColor(2)"
          class="ion-no-margin button"
          (click)="winner(2)"
          translate
        >
          Winner
        </ion-button>
      </ng-template>
    </ion-col>
  </ion-row>

  <!-- Row #2: SERVE WINNER | RETURN UNFORCED ERROR | FORCED ERROR -->
  <ion-row>
    <ion-col
      class="ion-no-padding"
      size="6"
      [style.--background]="getColor(1)"
      [ngStyle]="{ 'height.px': (screenHeight - 204) / 3 }"
    >
      <ion-button
        [disabled]="isBoardDisabled"
        *ngIf="
          bhs.getLastPoint(match).server.sideNumber === 1 && !isStatsBoard;
          else player1ReturnUFE
        "
        class="ion-no-margin button"
        [style.--background]="getColor(1)"
        (click)="serveWinner(1)"
      >
        {{ "Serve" | translate }}<br />{{ "Winner" | translate }}
      </ion-button>

      <ng-template #player1ReturnUFE>
        <ion-button
          [disabled]="isBoardDisabled"
          *ngIf="!isStatsBoard; else player1FE"
          class="ion-no-margin button"
          [style.--background]="getColor(1)"
          (click)="returnUnforcedError(1)"
        >
          {{ "Return" | translate }} <br />{{ "Unforced Error" | translate }}
        </ion-button>
      </ng-template>

      <ng-template #player1FE>
        <ion-button
          [disabled]="isBoardDisabled"
          class="ion-no-margin button"
          [style.--background]="getColor(1)"
          (click)="forcedError(1)"
          translate
        >
          Forced Error
        </ion-button>
      </ng-template>
    </ion-col>

    <ion-col
      class="ion-no-padding"
      size="6"
      [ngStyle]="{ 'height.px': (screenHeight - 204) / 3 }"
    >
      <ion-button
        [disabled]="isBoardDisabled"
        *ngIf="
          bhs.getLastPoint(match).server.sideNumber === 2 && !isStatsBoard;
          else player2ReturnUFE
        "
        [style.--background]="getColor(2)"
        class="ion-no-margin button"
        (click)="serveWinner(2)"
      >
        {{ "Serve" | translate }}<br />{{ "Winner" | translate }}
      </ion-button>

      <ng-template #player2ReturnUFE>
        <ion-button
          [disabled]="isBoardDisabled"
          *ngIf="!isStatsBoard; else player2FE"
          [style.--background]="getColor(2)"
          class="ion-no-margin button"
          (click)="returnUnforcedError(2)"
        >
          {{ "Return" | translate }} <br />{{ "Unforced Error" | translate }}
        </ion-button>
      </ng-template>

      <ng-template #player2FE>
        <ion-button
          [disabled]="isBoardDisabled"
          [style.--background]="getColor(2)"
          [style.--background]="getColor(2)"
          class="ion-no-margin button"
          (click)="forcedError(2)"
          translate
        >
          Forced Error
        </ion-button>
      </ng-template>
    </ion-col>
  </ion-row>

  <!-- Row #3: 1ST SERVER ERROR | DOUBLE FAULT | RETURN MADE | UNFORCED ERROR -->
  <ion-row [ngStyle]="{ 'height.px': (screenHeight - 204) / 3 }">
    <ion-col
      class="ion-no-padding"
      size="6"
      [ngStyle]="{ 'height.px': (screenHeight - 204) / 3 }"
    >
      <ion-button
        [disabled]="isBoardDisabled"
        *ngIf="
          bhs.getLastPoint(match).server.sideNumber === 1 &&
            !isStatsBoard &&
            !switchedServeButton;
          else player1DoubleFault
        "
        class="ion-no-margin button"
        [style.--background]="getColor(1)"
        (click)="firstServeError(1, 'O')"
        translate
      >
        {{ "1st Serve" | translate }}<br />{{ "Error" | translate }}
      </ion-button>

      <ng-template #player1DoubleFault>
        <ion-button
          [disabled]="isBoardDisabled"
          *ngIf="
            bhs.getLastPoint(match).server.sideNumber === 1 &&
              switchedServeButton &&
              !isStatsBoard;
            else player1ReturnMade
          "
          class="ion-no-margin button"
          [style.--background]="getColor(1)"
          (click)="doubleFault(1, 'O')"
          translate
        >
          Double Fault
        </ion-button>
      </ng-template>

      <ng-template #player1ReturnMade>
        <ion-button
          [disabled]="isBoardDisabled"
          *ngIf="!isStatsBoard; else player1UFE"
          class="ion-no-margin button"
          [style.--background]="getColor(1)"
          (click)="returnMade(1)"
          translate
        >
          Return Made
        </ion-button>
      </ng-template>

      <ng-template #player1UFE>
        <ion-button
          [disabled]="isBoardDisabled"
          class="ion-no-margin button"
          [style.--background]="getColor(1)"
          (click)="unforcedError(1)"
          translate
        >
          Unforced Error
        </ion-button>
      </ng-template>
    </ion-col>

    <ion-col
      class="ion-no-padding"
      size="6"
      [ngStyle]="{ 'height.px': (screenHeight - 204) / 3 }"
    >
      <ion-button
        [disabled]="isBoardDisabled"
        *ngIf="
          bhs.getLastPoint(match).server.sideNumber === 2 &&
            !isStatsBoard &&
            !switchedServeButton;
          else player2DoubleFault
        "
        [style.--background]="getColor(2)"
        class="ion-no-margin button"
        (click)="firstServeError(2, 'O')"
        translate
      >
        {{ "1st Serve" | translate }}<br />{{ "Error" | translate }}
      </ion-button>

      <ng-template #player2DoubleFault>
        <ion-button
          [disabled]="isBoardDisabled"
          *ngIf="
            bhs.getLastPoint(match).server.sideNumber === 2 &&
              switchedServeButton &&
              !isStatsBoard;
            else player2ReturnMade
          "
          [style.--background]="getColor(2)"
          class="ion-no-margin button"
          (click)="doubleFault(2, 'O')"
          translate
        >
          Double Fault
        </ion-button>
      </ng-template>

      <ng-template #player2ReturnMade>
        <ion-button
          [disabled]="isBoardDisabled"
          *ngIf="!isStatsBoard; else player2UFE"
          [style.--background]="getColor(2)"
          class="ion-no-margin button"
          (click)="returnMade(2)"
          translate
        >
          Return Made
        </ion-button>
      </ng-template>

      <ng-template #player2UFE>
        <ion-button
          [disabled]="isBoardDisabled"
          class="ion-no-margin button"
          [style.--background]="getColor(2)"
          (click)="unforcedError(2)"
          translate
        >
          {{'Unforced Error' | translate}}
        </ion-button>
      </ng-template>
    </ion-col>
  </ion-row>
  } @else {
  <app-empty-page
    *ngIf="match.score?.sets?.length"
    text="{{'Stats board is unavailable when servers are not being tracked' | translate}}"
    iconName="stats-chart"
  ></app-empty-page>
  }
</ion-grid>
} @else {
<ion-card class="content-width">
  <ion-card-header>
    <ion-card-subtitle>
      <ion-row class="ion-no-margin">
        <ion-col class="ion-no-padding"> {{ 'Match winner' | translate }} </ion-col>
        <ion-col
          class="ion-no-padding ion-text-right"
          size="1"
          style="cursor: pointer"
          (click)="undo()"
        >
          <ion-icon color="dark" name="arrow-undo"></ion-icon>
        </ion-col>
      </ion-row>
    </ion-card-subtitle>
    <ion-card-title>{{
      bhs.getPlayersNames(match, match.winningSide, "full")
    }}</ion-card-title>
  </ion-card-header>
</ion-card>
}

<ng-template #noStatsBoard> </ng-template>
